module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-error', {
    attrs: {
      "tooltip": "Страница сломалась",
      "code": "404",
      "alt": "404 - Ничего не найдено"
    }
  }, [_c('p', [_vm._v("Нам очень жаль, что так произошло. Мы обязательно исправим эту ошибку,")]), _c('p', [_vm._v("Извините, что недоглядели и спасибо за терпение.")]), _c('p', [_c('br'), _c('ext-button', {
    attrs: {
      "color": "green",
      "size": "medium",
      "factor": 1.2,
      "rounded": true,
      "shadow": true,
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("В каталог")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b30acf6","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 4e31023f3ebd89fd50fa
// module chunks = 0